import dayjs from "dayjs";
var customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

// action types
export const ADD_CONTACT_SYNCED_HISTORY = "addContactSyncedHistory";
export const CLEAR_CONTACT_SYNCED_HISTORY = "clearContactSyncedHistory";

// mutation types
export const SET_CONTACT_SYNCED_HISTORY = "setContactSyncedHistory";

const state = {
  history: JSON.parse(localStorage.getItem("contactSyncedHistory")) || []
};

const getters = {
  getContactSyncedHistory: state => state.history
};

const actions = {
  [ADD_CONTACT_SYNCED_HISTORY](state, payload) {
    state.state.history.push(payload);
    localStorage.setItem(
      "contactSyncedHistory",
      JSON.stringify(state.state.history)
    );
    state.commit(SET_CONTACT_SYNCED_HISTORY, state.state.history);
  },
  [CLEAR_CONTACT_SYNCED_HISTORY](state) {
    var history = [];
    state.state.history.forEach(item => {
      var dateCheck = dayjs().add(-14, "day");
      if (dayjs(item.created) > dateCheck) {
        history.push(item);
      }
    });

    state.state.history = history;
    localStorage.setItem(
      "contactSyncedHistory",
      JSON.stringify(state.state.history)
    );

    state.commit(SET_CONTACT_SYNCED_HISTORY, state.state.history);
  }
};

const mutations = {
  [SET_CONTACT_SYNCED_HISTORY](state, history) {
    state.history = history;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
